// Prices are integers in the API's existing currency unit.
export function invitationPriceError(row, editing = false) {
  // Regular and legacy SKUs retain their original validation flow.
  // Only the server's explicit invitation type enables the new price rules.
  if (row.registrationType !== 'INVITED') return null
  const price = Number(row.dealPrice)
  if (!Number.isSafeInteger(price) || price <= 0) return { key: 'positivePrice' }
  if ((row.salePrice !== null && row.salePrice !== undefined) && price >= Number(row.salePrice)) return { key: 'belowSalePrice' }
  let cap = row.maxRegistrationPrice
  if (editing && row.auditStatus === 2) {
    cap = (row.approvedPriceCap === null || row.approvedPriceCap === undefined) ? row.originalDealPrice : row.approvedPriceCap
  }
  if ((cap !== null && cap !== undefined) && price > Number(cap)) return { key: 'maximumPrice', amount: cap }
  return null
}

export function invitationReadKey(cookies) {
  const storeId = cookies.get('store-id')
  const account = cookies.get('user-account')
  return storeId && account ? `promotion-invitation-read:${storeId}:${account}` : null
}

export function isEnrollmentPage(path) {
  return /\/seller-center\/(activityintegrate|activity\/application)\/?$/.test(path)
}
